<template lang="">
    <div class="details">
        <div class="details-top">
            <div class="details-top-count">
                <div class="details-top-count-body">
                    <div class="body-count">
                        <div class="body-count-title">得分</div>
                        <div class="body-count-num">{{score}}</div>
                    </div>
                    <div class="body-r">
                        <div class="body-r-count">
                            <img class="body-r-count-i" src="../../assets/d-img/c-line.png" alt="业绩指标">
                            <div class="body-r-count-c">业绩指标</div>
                            <div class="body-r-count-b">{{1 == achievement ? '待优化' : '已达标'}}</div>
                        </div>
                        <div class="body-r-count" style="margin-top: 22px;">
                            <img class="body-r-count-i" src="../../assets/d-img/man.png" alt="业绩指标">
                            <div class="body-r-count-c">客户模型</div>
                            <div class="body-r-count-b">{{1 == customerModel ? '待优化' : '已达标'}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="details-bottom">
            <div class="details-bottom-count">
                <div class="count-top">
                    <div @click="activeFun(1)" :class="activeType == 1 ? 'count-top-title count-top-active' : 'count-top-title'">健康指标</div>
                    <div @click="activeFun(2)" :class="activeType == 2 ? 'count-top-title count-top-active' : 'count-top-title'">空间指标</div>
                </div>
                <div class="count-tips">
                    <img class="count-tips-img" src="../../assets/d-img/deng.png" alt="提示">
                    <span class="count-tips-text">{{activeText}}</span>
                </div>
                <div class="count-link">
                    <div class="count-link-l"></div>
                    <div class="count-link-t">业绩指标</div>
                </div>
                <div class="count-index">
                    <div class="count-index-body">
                        <div class="count-index-body-top">
                            <van-circle
                                v-model:current-rate="parameterInfo.achievement.capacityScale"
                                :rate="parameterInfo.achievement.capacityScale"
                                :speed="100"
                                :stroke-width="110"
                                layer-color="#F5F7FB"
                                color="#1AC69E"
                                v-if="100 == parameterInfo.achievement.capacityScale"
                            ></van-circle>
                            <van-circle
                                v-model:current-rate="parameterInfo.achievement.capacityScale"
                                :rate="parameterInfo.achievement.capacityScale"
                                :speed="100"
                                :stroke-width="110"
                                color="#FFC643"
                                layer-color="#F5F7FB"
                                v-else
                            ></van-circle>
                            <div class="c-point"></div>
                            <div class="circle-tips">年产能</div>
                            <div class="circle-b" v-if="2 == activeType">
                                <img class="circle-b-img" v-if="100 == parameterInfo.achievement.capacityScale" src="../../assets/d-img/success.png" alt="">
                                <img class="circle-b-img" v-else src="../../assets/d-img/tanhao.png" alt="">
                                <span :class="100 == parameterInfo.achievement.capacityScale ? 'circle-b-text circle-b-text-s' : 'circle-b-text'" >{{100 == parameterInfo.achievement.capacityScale ? '已达标' : '有空间'}}</span>
                            </div>
                            <div class="circle-b" v-else>
                                <img class="circle-b-img" v-if="100 == parameterInfo.achievement.capacityScale" src="../../assets/d-img/success.png" alt="">
                                <img class="circle-b-img" v-else src="../../assets/d-img/close.png" alt="">
                                <span :class="100 == parameterInfo.achievement.capacityScale ? 'circle-b-text circle-b-text-s' : 'circle-b-text'" >{{100 == parameterInfo.achievement.capacityScale ? '已达标' : '未达标'}}</span>
                            </div>
                        </div>
                        <div class="count-index-body-c">{{parameterInfo.achievement.capacity}}万元/年</div>
                        <div class="count-index-body-b">差距{{parameterInfo.achievement.disparityCapacity}}万元/年</div>
                    </div>
                    <div class="count-index-body">
                        <div class="count-index-body-top">
                            <van-circle
                                v-model:current-rate="parameterInfo.achievement.cashScale"
                                :rate="parameterInfo.achievement.cashScale"
                                :speed="100"
                                :stroke-width="110"
                                layer-color="#F5F7FB"
                                color="#1AC69E"
                                v-if="100 == parameterInfo.achievement.cashScale"
                            ></van-circle>
                            <van-circle
                                v-model:current-rate="parameterInfo.achievement.cashScale"
                                :rate="parameterInfo.achievement.cashScale"
                                :speed="100"
                                :stroke-width="110"
                                color="#FFC643"
                                layer-color="#F5F7FB"
                                v-else
                            ></van-circle>
                            <div class="c-point"></div>
                            <div class="circle-tips">现金业绩</div>
                            <div class="circle-b" v-if="2 == activeType">
                                <img class="circle-b-img" v-if="100 == parameterInfo.achievement.cashScale" src="../../assets/d-img/success.png" alt="">
                                <img class="circle-b-img" v-else src="'../../assets/d-img/tanhao.png'" alt="">
                                <span :class="100 == parameterInfo.achievement.cashScale ? 'circle-b-text circle-b-text-s' : 'circle-b-text'" >{{100 == parameterInfo.achievement.cashScale ? '已达标' : '有空间'}}</span>
                            </div>
                            <div class="circle-b" v-else>
                                <img class="circle-b-img" v-if="100 == parameterInfo.achievement.cashScale" src="../../assets/d-img/success.png" alt="">
                                <img class="circle-b-img" v-else src="'../../assets/d-img/close.png'" alt="">
                                <span :class="100 == parameterInfo.achievement.cashScale ? 'circle-b-text circle-b-text-s' : 'circle-b-text'" >{{100 == parameterInfo.achievement.cashScale ? '已达标' : '未达标'}}</span>
                            </div>
                        </div>
                        <div class="count-index-body-c">{{parameterInfo.achievement.cashAchievement}}万元/年</div>
                        <div class="count-index-body-b">差距{{parameterInfo.achievement.disparityCash}}万元/年</div>
                    </div>
                </div>
                <div class="count-list">
                    <div class="count-list-r">消耗业绩</div>
                    <div class="count-list-r">{{parameterInfo.achievement.consumeAchievement}}万/月</div>
                </div>
                <div class="count-list">
                    <div class="count-list-r">实操业绩</div>
                    <div class="count-list-r">{{parameterInfo.achievement.practicalAchievement}}万/月</div>
                </div>
                <div class="count-list">
                    <div class="count-list-r">产品业绩</div>
                    <div class="count-list-r">{{parameterInfo.achievement.productAchievement}}万/月</div>
                </div>
                <div class="count-link">
                    <div class="count-link-l"></div>
                    <div class="count-link-t">客户模型</div>
                </div>
                <div class="count-index">
                    <div class="count-index-body-model">
                        <div class="count-index-body-model-top">
                            <div class="model-c" v-if="100 == parameterInfo.customerModel.flowScale">
                                <van-circle
                                    v-model:current-rate="parameterInfo.customerModel.flowScale"
                                    :rate="parameterInfo.customerModel.flowScale"
                                    :speed="100"
                                    :stroke-width="100"
                                    layer-color="#F5F7FB"
                                    color="#1AC69E"
                                    size="2.1867rem"
                                ></van-circle>
                                <div class="model-poin"></div>
                            </div>
                            <div class="model-c" v-else>
                                <van-circle
                                    v-model:current-rate="parameterInfo.customerModel.flowScale"
                                    :rate="parameterInfo.customerModel.flowScale"
                                    :speed="100"
                                    :stroke-width="100"
                                    :color="'#FFC643'"
                                    layer-color="#F5F7FB"
                                    size="2.1867rem"
                                ></van-circle>
                                <div class="model-point"></div>
                            </div>
                            
                            <div class="model-b" v-if="2 == activeType">
                                <img class="model-b-img" v-if="100 == parameterInfo.customerModel.flowScale" src="../../assets/d-img/success.png" alt="">
                                <img class="model-b-img" v-else src="'../../assets/d-img/tanhao.png" alt="">
                                <span :class="100 == parameterInfo.customerModel.flowScale ? 'model-b-text circle-b-text-s' : 'model-b-text'" >{{100 == parameterInfo.customerModel.flowScale ? '已达标' : '有空间'}}</span>
                            </div>
                            <div class="model-b" v-else>
                                <img class="model-b-img" v-if="100 == parameterInfo.customerModel.flowScale" src="../../assets/d-img/success.png" alt="">
                                <img class="model-b-img" v-else src="'../../assets/d-img/close.png" alt="">
                                <span :class="100 == parameterInfo.customerModel.flowScale ? 'model-b-text circle-b-text-s' : 'model-b-text'" >{{100 == parameterInfo.customerModel.flowScale ? '已达标' : '未达标'}}</span>
                            </div>
                        </div>
                        <div class="model-center-title">月客流容量</div>
                        <div class="model-center-title">{{parameterInfo.customerModel.flow}}人次</div>
                        <div class="model-bottom-title">差距</div>
                        <div class="model-bottom-title">{{parameterInfo.customerModel.disparityFlow}}人次/月</div>
                    </div>

                    <div class="count-index-body-model">
                        <div class="count-index-body-model-top">
                            <div class="model-c" v-if="100 == parameterInfo.customerModel.customersNumScale">
                                <van-circle
                                    v-model:current-rate="parameterInfo.customerModel.customersNumScale"
                                    :rate="parameterInfo.customerModel.customersNumScale"
                                    :speed="100"
                                    :stroke-width="100"
                                    layer-color="#F5F7FB"
                                    color="#1AC69E"
                                    size="2.1867rem"
                                ></van-circle>
                                <div class="model-poin"></div>
                            </div>
                            <div class="model-c" v-else>
                                <van-circle
                                    v-model:current-rate="parameterInfo.customerModel.customersNumScale"
                                    :rate="parameterInfo.customerModel.customersNumScale"
                                    :speed="100"
                                    :stroke-width="100"
                                    :color="'#FFC643'"
                                    layer-color="#F5F7FB"
                                    size="2.1867rem"
                                ></van-circle>
                                <div class="model-poin"></div>
                            </div>
                            <div class="model-b" v-if="2 == activeType">
                                <img class="model-b-img" v-if="100 == parameterInfo.customerModel.customersNumScale" src="../../assets/d-img/success.png" alt="">
                                <img class="model-b-img" v-else src="../../assets/d-img/tanhao.png" alt="">
                                <span :class="100 == parameterInfo.customerModel.customersNumScale ? 'model-b-text circle-b-text-s' : 'model-b-text'" >{{100 == parameterInfo.customerModel.customersNumScale ? '已达标' : '有空间'}}</span>
                            </div>
                            <div class="model-b" v-else>
                                <img class="model-b-img" v-if="100 == parameterInfo.customerModel.customersNumScale" src="../../assets/d-img/success.png" alt="">
                                <img class="model-b-img" v-else src="../../assets/d-img/close.png" alt="">
                                <span :class="100 == parameterInfo.customerModel.customersNumScale ? 'model-b-text circle-b-text-s' : 'model-b-text'" >{{100 == parameterInfo.customerModel.customersNumScale ? '已达标' : '未达标'}}</span>
                            </div>
                        </div>
                        <div class="model-center-title">有效总客数</div>
                        <div class="model-center-title">{{parameterInfo.customerModel.customersNum}}人次</div>
                        <div class="model-bottom-title">差距</div>
                        <div class="model-bottom-title">{{parameterInfo.customerModel.disparityCustomersNum	}}人次/月</div>
                    </div>

                    <div class="count-index-body-model">
                        <div class="count-index-body-model-top">
                            <div class="model-c" v-if="100 == parameterInfo.customerModel.customersPriceScale">
                                <van-circle
                                    v-model:current-rate="parameterInfo.customerModel.customersPriceScale"
                                    :rate="parameterInfo.customerModel.customersPriceScale"
                                    :speed="100"
                                    :stroke-width="110"
                                    layer-color="#F5F7FB"
                                    color="#1AC69E"
                                    size="2.1867rem"
                                ></van-circle>
                                <div class="model-poin"></div>
                            </div>
                            <div class="model-c" v-else>
                                <van-circle
                                    v-model:current-rate="parameterInfo.customerModel.customersPriceScale"
                                    :rate="parameterInfo.customerModel.customersPriceScale"
                                    :speed="100"
                                    :stroke-width="110"
                                    :color="'#FFC643'"
                                    layer-color="#F5F7FB"
                                    size="2.1867rem"
                                ></van-circle>
                                <div class="model-poin"></div>
                            </div>
                            
                            <div class="model-b" v-if="2 == activeType">
                                <img class="model-b-img" v-if="100 == parameterInfo.customerModel.customersPriceScale" src="../../assets/d-img/success.png" alt="">
                                <img class="model-b-img" v-else src="../../assets/d-img/tanhao.png" alt="">
                                <span :class="100 == parameterInfo.customerModel.customersPriceScale ? 'model-b-text circle-b-text-s' : 'model-b-text'" >{{100 == parameterInfo.customerModel.customersPriceScale ? '已达标' : '有空间'}}</span>
                            </div>
                            <div class="model-b" v-else>
                                <img class="model-b-img" v-if="100 == parameterInfo.customerModel.customersPriceScale" src="../../assets/d-img/success.png" alt="">
                                <img class="model-b-img" v-else src="../../assets/d-img/close.png" alt="">
                                <span :class="100 == parameterInfo.customerModel.customersPriceScale ? 'model-b-text circle-b-text-s' : 'model-b-text'" >{{100 == parameterInfo.customerModel.customersPriceScale ? '已达标' : '未达标'}}</span>
                            </div>
                        </div>
                        <div class="model-center-title">必须客单价</div>
                        <div class="model-center-title">{{parameterInfo.customerModel.customersPrice}}元</div>
                        <div class="model-bottom-title">差距</div>
                        <div class="model-bottom-title">{{parameterInfo.customerModel.disparityCustomersPrice}}人次/月</div>
                    </div>
                </div>
                <div class="count-list">
                    <div class="count-list-r">最低留客率</div>
                    <div class="count-list-r">{{parameterInfo.customerModel.retentionRate}}%</div>
                </div>
                <div class="count-link">
                    <div class="count-link-l"></div>
                    <div class="count-link-t">应拓客人数</div>
                </div>
                <div class="count-index">
                    <div class="extension-body">
                        <div class="extension-body-num">
                            <span class="extension-body-num-l">{{parameterInfo.customerModel.tokerNum}}</span>
                            <span class="extension-body-num-r">人</span>
                        </div>
                    </div>
                </div>
                <div class="extension-bottom">
                    <div class="extension-bottom-img">
                        <img src="../../assets/d-img/flag.png" alt="客服">
                    </div>
                    <div class="extension-bottom-text">不盲目｜明确拓客目标，步步达成必须指标</div>
                    <!-- <div class="comma-l">“</div>
                    <div class="comma-r">”</div> -->
                </div>
            </div>
            <div class="details-bottom-count" style="margin-top: 16px" >
                <div class="scheme">
                    <div class="scheme-l">
                        <div class="scheme-line"></div>
                        <div class="scheme-round"></div>
                    </div>
                    <div class="scheme-title">有方案·有团队·出结果</div>
                    <div class="scheme-r">
                        <div class="scheme-round"></div>
                        <div class="scheme-line"></div>
                    </div>
                </div>
                <div class="scheme-tab">
                    <div 
                        :class="tabId == item.id ? 'scheme-tab-default scheme-tab-active': 'scheme-tab-default'" 
                        v-for="item in tabList" 
                        :key="item.id" 
                        :index="item.id + 'tab'"
                        @click="checkTab(item.id)"
                    >{{item.name}}</div>
                </div>
                <van-empty v-if="isEmpty" description="暂无数据" />
                <van-pull-refresh v-else v-model="refreshing" @refresh="onRefresh" >
                    <van-list
                        v-model:loading="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                    >
                        <div class="scheme-card" v-for="(item, index) in commodityList" :key="item.id" :index="index" >
                            <div class="card-title">
                                <span class="card-title-l">11.4</span>
                                <span class="card-title-r">倍回报率</span>
                            </div>
                            <div class="card-body">
                                <img class="card-body-img" :src="item.coverImage" alt="方案头图">
                                <div class="card-body-r">
                                    <div class="card-body-r-title">{{item.title}}</div>
                                    <div class="card-body-r-btn">
                                        <div class="card-price">
                                            <span class="card-price-l">￥</span>
                                            <span class="card-price-r">{{item.price}}</span>
                                        </div>
                                        <van-button type="default" color="#0F50C5" size="small" @click="getCooperationProgram(item.id)">方案合作</van-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </van-list>
                </van-pull-refresh>
            </div>
        </div>
        <div class="bottom-btn" @click="jumpCustomerServic()">
            <img src="../../assets/d-img/consultant.png" alt="">
            <!-- <van-button 
                type="primary" 
                color="#0F50C5" 
                size="large" 
                
                icon="https://fastly.jsdelivr.net/npm/@vant/assets/user-active.png"
            >咨询经营顾问</van-button> -->
        </div>
    </div>
</template>

<script>
import { getStore } from "../../utils/util";
import { customerService } from "../../utils/getCustomerService"
import { jumpProgram } from '../../utils/jumpProgram'
import { getUrlKey } from '../../utils/util'
export default {
    // 经营诊断  有数据
    name: 'DiagnosisDetails',   
    data() {
        return {
            activeType: 1,
            activeText: '开店不应只是为了保本，健康运营的必须指标',
            capacityVal: 100,
            tabId: 1,
            rate: 100,
            tabList: [],
            loading: false,
            score: 0, // 得分
            parameterInfo: {}, // 指标
            modelObj: {}, 
            page: 1,
            token: '',
            currentRate: 30,
            commodityList: [],
            isEmpty: false,
            refreshing: false,
            finished: false,
            achievement: 0,
            customerModel: 0,
            sid: 0,
            cid: 0
        }
    },
    created() {
        // this.token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2ODIyMzI0MTIsImp4dF9BZ2VudElkIjoxMDAyMjksImp4dF9BZ2VudE5hbWUiOiLku6PnkIbllYYt5ZCN56ewIiwianh0X0xvZ2luS2V5IjoiMTg3NzY5MTgwMzQiLCJqeHRfTG9naW5UeXBlIjoicGhvbmUiLCJqeHRfUGhvbmUiOiIxODc3NjkxODAzNCIsImp4dF9TdG9yZUlkIjoxNTM5LCJqeHRfU3RvcmVOYW1lIjoi6YCX5ZOl55qE5bqXIiwianh0X1VzZXJJZCI6MzA3MCwianh0X1VzZXJOYW1lIjoi5b6X5oiR5bqf54mpIiwianh0X1VzZXJUeXBlIjoyMywib3JpZ19pYXQiOjE2NzM1OTI0MTJ9.q-c_0gVBBtdKtzY0xJ9zbiWgsbkImYBUmxU-L7MOBmA'
        // const token = ref('')
        // getAppToken().then(() => {
        //     this.token = localStorage.getItem('appToken')
        // });
        let obj = getStore('diagnosis')
        this.score = obj.score
        this.achievement = obj.achievement
        this.customerModel = obj.customerModel
        this.parameterInfo = obj.healthIndicators
        this.tabList = obj.classList
        this.sid = getUrlKey('sid')
        this.cid = getUrlKey('cid')
        if(obj.classList.length > 0) {
            this.getstorePlan(obj.classList[0].id)
            this.loading = false
        }
        
        
    },
    methods: {
        activeFun(e) {
            this.activeType = e
            this.activeText = 1 == e ? '开店不应只是为了保本，健康运营的必须指标' : '可达到的峰值指标，实现门店盈利最大化'
            let obj = getStore('diagnosis')
            this.parameterInfo = 1 == e ? obj.healthIndicators : obj.spaceIndicators
        },
        checkTab(e) {
            this.tabId = e
            // 清空列表数据
            this.finished = false;
            this.page = 1
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.getstorePlan(e)
        },
        // /h5/store_plan
        getstorePlan(id) {
            this.$http.post(
                '/h5/store_plan', 
                { id: id, size: 10, page: this.page, storeId: this.sid },
                { headers: { Authorization: 'Bearer ' +  this.token, 'content-type' : 'application/json; charset=utf-8' } }
            ).then(({ data: res }) => {
                if(res.success) {
                    let pageVal = this.page
                    const resList = this.page == 1 ? [] : this.commodityList
                    const _new = res.data.list || []
                    resList.push(..._new)
                    pageVal += 1
                    this.page = pageVal
                    this.commodityList = resList
                    this.loading = false;
                    if(res.data.list.length < 10) {
                        this.finished = true
                    }
                    if(resList.length == 0) {
                        this.isEmpty = true
                    }
                } else {
                    this.$toast.fail(res.errorMessage);
                }
            })
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
        },
        // 获取合作方案
        getCooperationProgram(id) {
            this.$http.post(
                '/h5/store_mini', 
                { id: id },
                { headers: { Authorization: 'Bearer ' +  this.token, 'content-type' : 'application/json; charset=utf-8' } }
            ).then(({ data: res }) => {
                if(res.success) {
                    let obj = res.data
                    obj.sid = this.sid
                    obj.cid = this.cid
                    jumpProgram(obj)
                } else {
                    this.$toast.fail(res.errorMessage);
                }
            })
        },

        // 客服/base/kefu
        jumpCustomerServic() {
            this.$http.post('/base/kefu').then(({ data: res }) => {
                if(res.success) {
                    customerService(res.data)
                } else {
                    this.$toast.fail(res.errorMessage);
                }
            })
        }
    },
    mounted() {

    },
}
</script>
<style scoped lang="scss" src="./index-details.scss"></style>
